<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.mn" filterable  @change="getFactorsByMn">
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn" filterable  @change="getFactorsByMn">
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="因子">
					<el-select v-model="filters.facKeyword" style="max-width:150px" filterable>
					<el-option
							v-for="item in factors"
							:label="item.name"
							:value="item.keyword" :key="item.keyword">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="时间">
					<el-date-picker v-model="filters.time" type="date" placeholder="选择日" value-format="yyyy-MM-dd"> </el-date-picker>
                </el-form-item>
				<el-form-item>
                     <form-query-button  @select-type="getAnalysisData" >  </form-query-button>
				</el-form-item>
			</el-form>
		</el-col>

		<el-table :data="dataList" border highlight-current-row v-loading="listLoading" style="width: 100%;" size="small" id="mytable">
            <!-- <el-table-column  label="项目名称"  >
				<template slot-scope="scope">
					<span >{{projectMap.get(scope.row["mn"])}}</span>
				</template>
			</el-table-column> -->

			<el-table-column label="点位名称"    >
				<template slot-scope="scope" >
					<span >{{deviceMap.get(scope.row["mn"])}}</span>
				</template>
			</el-table-column>

            <el-table-column prop="mn" label="设备编码"   v-if="type==0" ></el-table-column>

            <el-table-column prop="type" label="数据类型" >
                <template slot-scope="scope">
					<span v-if="scope.row.type==0">自动数据</span>
                    <span v-else-if="scope.row.type==1">手工数据</span>
                    <span v-else>差值</span>
				</template>
            </el-table-column>
           <el-table-column
				v-for="(item,i) in aData" :prop="item" :label="item" :key="item" min-width="60">
				<template slot-scope="scope">
                    <span v-if="scope.row.type==2&&(scope.row.list[i]>1||scope.row.list[i]<-1)" style="color:red;font-weight: bold;">{{scope.row.list[i]}}</span>
                    <span v-else>{{scope.row.list[i]}}</span>
				</template>
			</el-table-column>
		</el-table>

        <el-col :span="24"   v-loading="listLoading">
            <div id="chartLine"></div>
        </el-col>
	</section>
</template>

<script>
	import { getProjects,getAnalysisData,getDevicesByProjectId,getFactorsByMn} from '../../api/api';
    import * as echarts from "echarts";   
    import {formatDate,pad2} from '../../../static/fun.js';

    import FormQueryButton from '../../components/myButton/FormQueryButton.vue'

    export default {
        props: {
            collapsed: {
                type: Boolean,
            },
        },
        components: { FormQueryButton },
		data() {
			return {
				pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                filters: {
					projectId:"",
					mn:"",
                    facKeyword:'',
                    time:''
				},
				listLoading: false,
				dataList:[],
				projects:[],
                devices:[],
                factors:[],

                userId:sessionStorage.getItem('userId'),
                chartLine:null,
                type:sessionStorage.getItem("type"),
                formHeight:0,
                aData:[],
                deviceMap:new Map(),
                projectMap:new Map(),
                firstFlag:true,
			}
			
		},
        watch: {
            'collapsed': {
                handler (val) {
                    if(this.chartLine!=null){
                        this.chartLine.resize();
                    }
                },
                deep: true
            },
        },
		methods: {
            reset(){
                this.filters={
                    projectId:"",
					mn:"",
                    facKeyword:'',
                    time:''
                }
            },
            getAnalysisData(){
				let para = {
                    mn:this.filters.mn,
                    factor:this.filters.facKeyword,
                    time: this.filters.time
				};
                if(para.mn==""){
                    this.$message({
                        message: "请选择设备",
                        type: 'warn'
                    })
                    return;
                }
                if(para.time==""){
                    this.$message({
                        message: "请选择时间",
                        type: 'warn'
                    })
                    return;
                }
                 if(para.factor==""){
                    this.$message({
                        message: "请选择监测因子",
                        type: 'warn'
                    })
                    return;
                }
				this.listLoading = true;
                getAnalysisData(para).then((res) => {  //todo
                    this.listLoading = false;
                    if(res.data.result==false){
                        this.$message({
                            message: "查询出错,请重试",
                            type: 'warn'
                        })
                        return;
                    }else{
                        this.dataList = res.data.data; 
                        var seriesData=[
                            {
                                type:'line',
                                name:'人工数据',
                                connectNulls:false,
                                smooth:true,
                                color:'#02e050',
                                data:[]
                            },
                            {
                                type:'line',
                                name:'自动数据',
                                connectNulls:false,  
                                smooth:true,
                                color:'#48c8ed',
                                data:[]
                            }
                        ];
                        this.aData=[];
                        this.dataList.forEach(element => {
                            if(element.type==1){
                                seriesData[0].data=element.list;

                                for (let index = 0; index < element.listTime.length; index++) {
                                    const timeOne = element.listTime[index];
                                    var time=timeOne.split(' ')[1].split(':')[0]+"时";
                                    this.aData.push(time)
                                }

                            }else{
                                seriesData[1].data=element.list;
                            }
                        });

                        var obj={
                            mn:"",
                            type:2,
                            list:[]
                        }
                        
                        for (let index = 0; index < this.aData.length; index++) {
                            var a=Number(this.dataList[0].list[index]);
                            var b=Number(this.dataList[1].list[index]);
                           if(!isNaN(a)&&!isNaN(b)){
                                obj.list.push((a-b).toFixed(2));
                           }else{
                                obj.list.push("-");
                           }
                        }
                        this.dataList.push(obj);
                        this.drawLineChart(this.aData,seriesData);
                    }
                });
            },
            drawLineChart:function(aData,seriesData) {
                this.chartLine = echarts.init(document.getElementById('chartLine'));
                this.chartLine.setOption({
                      tooltip: {
                        trigger: 'axis',
                        formatter: function(params) {
                            var result = params[0].name+'<br>';
                            params.forEach(function(item) {
                                result +=item.seriesName+" : "+'<span style="display:inline-block;min-width:80px">'+ item.data+"</span><br>"
                            });
                            return result;
                        },
                    },
                    toolbox: {
                        show : true,
                        feature: {
                            saveAsImage: {
                                show:true,
                                excludeComponents :['toolbox'],
                                pixelRatio: 2
                            }
                        }
                    },
                    legend: {
                        itemWidth: 10,  // 设置宽度
                        itemHeight: 10, // 设置高度
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        top:60,
                        containLabel: true
                    },
                    xAxis: {
                        boundaryGap: true,
                        name:'时间',
                        data:aData
                    },
                    yAxis: {
                        type: 'value',
                        name:'数值(dB)',
                        scale:true
                    },
                    series:seriesData
                 },true);
            },
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
                    if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
            	//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
                    this.filters.deviceId="";
                    this.devices.forEach(item => {
						this.deviceMap.set(item.mnCode,item.name);
						this.projectMap.set(item.mnCode,item.projectName);
                    });
                    if(this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
                        this.getFactorsByMn();
					}
				});
            },
            //获取选中设备可监测的因子
            getFactorsByMn(){
                let para = {
                    mn: this.filters.mn.toString(),
                    dataType:this.dataType
                };
				getFactorsByMn(para).then((res) => {
                    this.factors = res.data.data;
                    if(this.factors.length>0){
                        this.filters.facKeyword=this.factors[0].keyword;
                        if(this.firstFlag){
                            this.firstFlag=false;
                            this.getAnalysisData();
                        }
                    } 
				});
            },
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				this.formHeight=(hgt-titleHgt-120);

                
                var chartLineDiv=document.getElementById("chartLine");
                if(chartLineDiv!='-'){
                    chartLineDiv.style.height=this.formHeight*0.6+"px";
                    document.getElementById("mytable").style.height=this.formHeight*0.3+"px";
                }
			},
			setTime(){
				var start = new Date();
				//设置不同的时间区间
                start.setTime(start.setDate(start.getDate()-1));
				this.filters.time=start.getFullYear()+"-"+pad2((start.getMonth()+1))+"-"+pad2((start.getDate()));
			}
		},
		mounted() {
			var _this=this;
			var timer='-';
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.setTime();
			this.getProjects();
 
            window.onresize = function(){
                if(_this.chartLine!=null){
                    _this.chartLine.resize();
                }
            }
		},
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }
    #mytable{
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// DataComparison.vue?7a2688b8